import React from "react";
import LogoSVG from "./logo.inline.svg";

import * as s from "./title.module.css";
import { T } from "../../components";

export const Title = () => {
	return (
		<div className={s.box}>
			<div>
				<LogoSVG className={s.logo} />
				<h1 className={s.title}>
					<T id="title" />
				</h1>
			</div>
			<h2 className={s.subtitle}>
				<T id="subtitle" />
			</h2>
		</div>
	);
};
